module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f00992d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/HealthCareProfessional/Layout.vue
// module id = 3744
// module chunks = 1